export const INVALID_URL_ERROR_MESSAGE =
  "L'url de l'article est invalide et ne peut pas être ajoutée";

export const AUTHORS_LABEL = 'Auteur(s)';
export const SOURCE_LABEL = 'Rechercher une source';
export const SLUG_LABEL = 'Slug';
export const LINK_TITLE_IA_SUGGESTIONS =
  'https://title-assistant.seotech.pm/?AzInATBH2qD';
